var CheckOrderAddon = (function ($) {

    function openCheckOrderFormInPopup(response) {
        $.fancybox({
            width: 500,
            height: "auto",
            content: response,
            fitToView: true,
            autoSize: false,
            afterShow: function() {
                initializeCheckOrderFormControls();
            },
            helpers: {
                overlay: {
                    locked: true
                }
            }
        });
    }

    function handleCheckOrderForm(response) {
        var responsePage = $($.parseHTML(response));
        var errorContainer = responsePage.find("#check-order-status-error-container");
        var captchaErrorMessageContainer = responsePage.find(".captcha-error-message-container").first();
        if (errorContainer.length || captchaErrorMessageContainer.length) {
            openCheckOrderFormInPopup(response);
            messageOverlay.showError("");
            messageOverlay.hideSlow();
            return;
        }

        var successMessage = responsePage.find("#check-order-success-message");
        if (successMessage.length) {
            messageOverlay.showClosableSuccess(successMessage.val());
            return;
        }

        messageOverlay.showError("");
        messageOverlay.hideSlow();
    }

    function handleCheckOrderFormOnLogin(response) {
        var responsePage = $($.parseHTML(response));
        var errorContainer = responsePage.find("#check-order-status-error-container-login-page");
        var captchaErrorMessageContainer = responsePage.find(".captcha-error-message-container").first();
        var checkOrderStatusLogin = $('.check-order-status-container');
        if (errorContainer.length || captchaErrorMessageContainer.length) {
            checkOrderStatusLogin.html(response);
            messageOverlay.showError("");
            messageOverlay.hideSlow();
            return;
        }

        var successMessage = responsePage.find("#check-order-success-message-login-page");
        if (successMessage.length) {
            messageOverlay.showClosableSuccess(successMessage.val());
            return;
        }

        checkOrderStatusLogin.html(response);
        messageOverlay.showError("");
        messageOverlay.hideSlow();
    }

    function handleCheckOrderFormError() {
        messageOverlay.showError("");
        messageOverlay.hideSlow();
    }

    function initializeCheckOrderFormControls(onLogin) {
        var loginAppend = onLogin ? '-login-page' : '';
        $("#check-order-status-form" + loginAppend).on('submit', function (event) {
            event.preventDefault();

            var token = $("input[name='_csrf']").val();
            var header = "X-CSRF-TOKEN";
            var payload = $("#check-order-status-form" + loginAppend).serializeArray();
            payload.forEach(function (item) {
                if (item.name === 'rdNumber') {
                    item.value = item.value.replace(/\D+/g, "");
                }
            });

            $("#check-order-status-error-container" + loginAppend).remove();
            initOverlaySpinner("");
            var url = onLogin ? "/order/check-status?onLogin=true" : "/order/check-status";
            $.ajax({
                url: url,
                type: "POST",
                data: payload,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader(header, token);
                }
            }).done(
                function(response) {
                    if(onLogin) {
                        handleCheckOrderFormOnLogin(response);
                    } else {
                        handleCheckOrderForm(response);
                    }
                }

            ).fail(handleCheckOrderFormError);
        });
    }

    function initialize() {
        $(".check-order-status-link").on('click', function (event) {
            event.preventDefault();

            $.ajax({
                url: "/order/check-status",
                type: "GET",
                cache: false
            }).done(function (response) {
                openCheckOrderFormInPopup(response);
            });
        });
    }

    return {
        initialize: initialize,
        initializeCheckOrderFormControls : initializeCheckOrderFormControls
    };

})($);

$(function () {
    CheckOrderAddon.initialize();
});